import {
	lazy,
} from 'react';
import {
	PATHS,
} from '@routes/paths';

// LAZY LOADING
const TabReport = lazy(() =>
	import('@layouts/Pages/PageSpecification/report').then((module) => ({
		default: module.Report,
	})),
);
const TabManage = lazy(() =>
	import('@layouts/Pages/PageSpecification/manage').then((module) => ({
		default: module.Manage,
	})),
);

export const SPECIFICATION_REPORT_ROUTES = [
	{
		element: <TabReport />,
		path: PATHS.SPECIFICATIONS.REPORT,
	},
];

export const SPECIFICATION_MANAGE_ROUTES = [
	{
		element: <TabManage />,
		path: PATHS.SPECIFICATIONS.MANAGE._ROOT,
	},
	{
		element: <TabManage />,
		path: PATHS.SPECIFICATIONS.MANAGE.STEP._ROOT,
	},
	{
		element: <TabManage />,
		path: PATHS.SPECIFICATIONS.MANAGE.STEP.OFFER._ROOT,
	},
];

export const SPECIFICATION_ROUTES = [
	...SPECIFICATION_MANAGE_ROUTES,
	...SPECIFICATION_REPORT_ROUTES,
];
